import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "#challenge", label: "The Challenge", testid: "nav-link-challenge" },
  { id: "#solution", label: "The Model", testid: "nav-link-services" },
  { id: "#flow", label: "Financial Flow", testid: "nav-link-flow" },
  { id: "#dashboard", label: "Control Room", testid: "nav-link-dashboard" },
  { id: "#industries", label: "Industries", testid: "nav-link-industries" },
  { id: "#about", label: "About", testid: "nav-link-about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header className="fixed inset-x-0 top-0 z-50 border-b border-slateink/10 bg-white">
      <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-6 lg:px-10">
        <button data-testid="nav-logo" onClick={() => go("#hero")} className="group flex items-center" aria-label="VERIVISTA Advisory — home">
          <img
            src="/assets/verivista-logo-full.png"
            alt="VERIVISTA Advisory LLP"
            className="h-11 w-auto transition-transform duration-300 group-hover:scale-[1.03] sm:h-14"
          />
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-bodylight transition-colors hover:text-inkred"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <button
            data-testid="nav-cta-button"
            onClick={() => go("#contact")}
            className="bg-gold px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-ink transition-all duration-300 hover:bg-gold-bright"
          >
            Request Consultation
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="text-slateink lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slateink/10 bg-white px-6 py-6 lg:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-${l.testid}`}
                onClick={() => go(l.id)}
                className="text-left font-mono text-xs uppercase tracking-[0.22em] text-bodylight"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-cta-button"
              onClick={() => go("#contact")}
              className="mt-2 bg-gold px-5 py-3 text-center font-mono text-[11px] uppercase tracking-[0.22em] text-ink"
            >
              Request Consultation
            </button>
          </div>
        </div>
      )}
    </motion.header>
  );
}
